import { ViewController, InactivityController, JsonFeed, ModelUpdateEvent, TimeoutEvent, DataReceiveEvent, MaintenanceEvent,
         VideoReloadEvent, GuiResizeEvent, TimeUpdateEvent, RelayoutEvent, ChannelSwitchEvent, BetPlaceEvent, WIDGET_LIVETABLE } from "@gaming/srvg-classes-core";
import { CollapsedView } from "../../View/AppView/CollapsedView";
import { GuiSwitchController } from "../GuiSwitchController";
import { LiveTableController } from "../LiveTableController";
import { OverlayViewController } from "./OverlayViewController";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";


export class CollapsedViewController extends ViewController {
    collapsedView: CollapsedView;

    guiSwitchController: GuiSwitchController;
    inactivityController: InactivityController;
    liveTableController: LiveTableController;
    overlayViewController: OverlayViewController;
    titlebarController: TitlebarController;
    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;

    constructor( options ) {
        options = options || {};
        options.view = options.collapsedView ||null;
        super( options );
        this.name = 'vblWebViewController';

        this.collapsedView = options.collapsedView || null;

        /******************* initialize controllers ************************/

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.collapsedView.videoView,
            videoControlBar: this.collapsedView.videoControlBar,
            channel: srvg.videooptions.defaultchannel
        } ) );

        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.collapsedView.titlebar } ) );
        this.inactivityController     = new InactivityController( { timeout: 2*60*60*1000 } );
        this.guiSwitchController      = this.addChildViewController( new GuiSwitchController({
            button: this.collapsedView.guiSwitch,
            wrapper: '#wrapper',
            compactClass: 'compact_view',
            skillClass: 'skill_view',
            shouldToggleContainer: true
        }) );
        this.liveTableController      = this.addChildViewController( new LiveTableController( {
            button: '#livetable_button',
            liveTable: this.collapsedView.liveTable,
            liveTableWidget: srvg.widgets[WIDGET_LIVETABLE].enabled ? this.collapsedView.widgetLivetable : null
        }) );
        this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
            overlayView: this.collapsedView.overlayContainerView,
            teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
            teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
        } ) );

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.collapsedView.matchdayArea
        }) );

        /******************* connect components ************************/

        // TODO replace eventType strings with event classes

        if( this.collapsedView.matchdayArea.matchdayPicker ) {
            // FIXME move
            this.matchdayAreaController.addSubscriberForEvent( app.customerIntegration, ModelUpdateEvent );
            this.inactivityController.addSubscriberForEvent( this.matchdayAreaController.matchdaypickerController, TimeoutEvent );
        }
        this.collapsedView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.oddsfeedController, ModelUpdateEvent );
        this.collapsedView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
        app.matchIdsFeedController.addSubscriberForEvent( app.customerIntegration, DataReceiveEvent );

        app.oddsfeedController.addSubscriberForEvent( this.matchdayAreaController, DataReceiveEvent );

        app.timelineController.addSubscriberForEvent( srvg.maintenance,           MaintenanceEvent );
        app.timelineController.addSubscriberForEvent( app.customerIntegration,    PhaseChangeEvent  );
        app.timelineController.addSubscriberForEvent( this.titlebarController,    PhaseChangeEvent  );
        app.timelineController.addSubscriberForEvent( app.server,                 TimeUpdateEvent  );
        app.timelineController.addSubscriberForEvent( this.overlayViewController, PhaseChangeEvent  );
        app.timelineController.addSubscriberForEvent( this.videoController,       VideoReloadEvent );

        this.inactivityController.addSubscriberForEvent( this.titlebarController, TimeoutEvent );
        this.inactivityController.addSubscriberForEvent( app.timelineController, TimeoutEvent );
        this.inactivityController.addSubscriberForEvent( this.videoController, TimeoutEvent );
        this.inactivityController.addSubscriberForEvent( app.customerIntegration, TimeoutEvent );

        this.collapsedView.matchdayArea.oddsGallery.addSubscriberForEvent( app.customerIntegration, BetPlaceEvent );
        this.guiSwitchController.addSubscriberForEvent( app.customerIntegration, GuiResizeEvent );
        this.liveTableController.addSubscriberForEvent( app.customerIntegration, GuiResizeEvent );


        if( srvg.widgets[WIDGET_LIVETABLE].enabled ) {
            this.collapsedView.liveTable.addSubscriberForEvent(this.liveTableController, RelayoutEvent);
        }

        var exch = srvg.eventExchange;

        exch.addEventHandler(this.videoController,             'all',                          ChannelSwitchEvent );
        exch.addEventHandler(this.overlayViewController,       'all',                          ChannelSwitchEvent );
        exch.addEventHandler(app.customerIntegration,          'all',                          ChannelSwitchEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        this.inactivityController.startWaiting();
        this.videoController.play();
        app.customerIntegration.startCustomerActions();
    }
}